import type { SVGProps } from "react";

export function IconBlueArrowRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_8880_5883)">
        <rect opacity="0.5" width="56" height="56" fill="#E4E7FC" />
        <path
          d="M18.668 40V16L40.0013 28L18.668 40Z"
          fill="#5486FA"
          stroke="#5486FA"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M18.668 28H25.168"
          stroke="#1C1719"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_8880_5883">
          <rect width="56" height="56" rx="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
